export const COMPANY_NAME = 'Maia Tecnologia LTDA';
export const COMPANY_CNPJ = '60.433.326/0001-34';
export const COMPANY_EMAIL = 'contato@okmaia.com';
export const LEGAL_LAST_UPDATED = '6 de julho de 2026';
